import { getLocale } from '@infl-ts/util-date';
import { useLanguage } from '@infl-ts/util-i18n-provider';
import { Box, Divider, Typography } from '@mui/material';
import { format, parseISO } from 'date-fns';
import * as A from 'fp-ts/Array';
import { constNull, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { useTranslation } from 'react-i18next';
import { Points } from '../points';
import { ProgressBar } from '../progress-bar';
import { ActivityCard } from './in-progress-activity-card';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var CompletedActivityCard = function CompletedActivityCard(_ref) {
  var activity = _ref.activity,
      isSelected = _ref.isSelected,
      pointsEarned = _ref.pointsEarned;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    "data-element": "Box",
    "data-component": "CompletedActivityCard",
    "data-source-file": "complete-activity-card.tsx",
    children: [/*#__PURE__*/_jsxs(ActivityCard, {
      isSelected: isSelected,
      "data-element": "ActivityCard",
      "data-component": "CompletedActivityCard",
      "data-source-file": "complete-activity-card.tsx",
      children: [pipe(activity.timeline, O.fromNullable, O.chain(A.findLast(function (entry) {
        return entry.createdAt !== null;
      })), O.map(function (lastTimelineEntry) {
        return lastTimelineEntry.createdAt;
      }), O.matchW(constNull, function (lastActivityTime) {
        return /*#__PURE__*/_jsxs(Typography, {
          component: "div",
          sx: {
            mb: 2,
            fontWeight: function fontWeight(t) {
              return t.typography.fontWeightBold;
            }
          },
          variant: "caption",
          children: [activity.state === 'rejected' ? t('Rejected') : t('Completed'), ":", ' ', lastActivityTime ? format(parseISO(lastActivityTime), 'E, MMM d, yyyy', {
            locale: getLocale(currentLang)
          }).toString() : 'n/a']
        });
      })), /*#__PURE__*/_jsx(ProgressBar, {
        color: activity.state === 'rejected' ? 'primary' : 'success',
        progress: 100,
        "data-element": "ProgressBar",
        "data-component": "CompletedActivityCard",
        "data-source-file": "complete-activity-card.tsx"
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          mt: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        },
        "data-element": "Box",
        "data-source-file": "complete-activity-card.tsx",
        children: /*#__PURE__*/_jsxs(Typography, {
          sx: {
            display: 'flex',
            gap: 0.5
          },
          component: "div",
          variant: "caption",
          "data-element": "Typography",
          "data-source-file": "complete-activity-card.tsx",
          children: [/*#__PURE__*/_jsx(Points, {
            sx: {
              mr: 0.25,
              pb: 0.25,
              height: 16,
              width: 16
            },
            variant: "caption",
            points: pointsEarned,
            "data-element": "Points",
            "data-source-file": "complete-activity-card.tsx"
          }), t('earned')]
        })
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      "data-element": "Divider",
      "data-source-file": "complete-activity-card.tsx"
    })]
  });
};

export default CompletedActivityCard;